import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import state from './state'
import actions from './actions'
import getters from './getters'
import profile from './modules/profile'
import returnStore from './modules/return'
import user from './modules/user'
import orders from './modules/orders'
import bill from './modules/bill'
import closeDocs from './modules/closeDocs'
import subscribe from './modules/subscribe'
import reconciliation from './modules/reconciliation'
import depository from './modules/depository'
import order from './modules/order'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    profile,
    return: returnStore,
    user,
    orders,
    bill,
    closeDocs,
    subscribe,
    reconciliation,
    depository,
    order,
    auth
  },
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/components/store/index.js